import { Component, HostListener, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChartData, MultiLineChartComponent } from '../../../../_shared';
import { DateFilterComponent } from '../../../../../_shared/components';
import { DateIntervalFilterData } from '../../../../../_shared/models';
import { DateInterval } from '../../../../../_shared/enums';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-full-linechart-fuel',
  standalone: true,
  imports: [MultiLineChartComponent, DateFilterComponent, TranslocoDirective],   // BigCostLinechart
  templateUrl: './full-linechart-fuel.component.html',
  styleUrl: './full-linechart-fuel.component.scss'
})
export class FullLinechartFuel {
  // Mock headline figures until the API supplies this summary.
  protected readonly headline = { value: 'R 22.4 /ℓ', change: '+19.29%' };
  protected fuelCostChartData = ChartData.fuelCostTw;
  protected fuelCostChartConfig = ChartData.fuelCostConfig;
  protected yConfig = { prefix: 'R ', suffix: '/ℓ', yTickFormat: ((d: any) => `${d}/ℓ`), yStartsFromZero: false };

  private readonly modalRef = inject(NgbActiveModal);

  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  public utilizationDateFilter: DateIntervalFilterData;
  public defaultInterval: DateInterval = DateInterval.Day;

  constructor() {
    this.utilizationDateFilter = {} as DateIntervalFilterData;
  }

  onUtilizationDateFilterChange(filter: DateIntervalFilterData): void {
    this.utilizationDateFilter = filter;
  }

  protected closeModal(): void {
    this.modalRef.close();
  }
}
